webpackJsonp([65140105295766],{

/***/ "./node_modules/json-loader/index.js!./.cache/json/shop-merino-chunky-blanket.json":
/***/ (function(module, exports) {

	module.exports = {
		"pathContext": {
			"path": "/shop/merino-chunky-blanket/"
		}
	};

/***/ })

});


// WEBPACK FOOTER //
// path---shop-merino-chunky-blanket-93a842d36d3560fc2486.js